<template>
  <modal name="WrapperModal" class="z-index-full" width="1000" height="auto" :min-height="500"
    :min-width="300" :resizable="true" :scrollable="true" :reset="true" :adaptive="true" :clickToClose="false">

    <p class="title"> {{ modal.title }}
      <!-- <button type="button" class="close text-white" aria-label="Close" @click.prevent="$modal.hide('WrapperModal')" >
        <span aria-hidden="true">&times;</span>
      </button> -->
    </p>

    <component :is="getComponent.compoment" v-bind="extra" @mounted="compomentIsReady" v-loading="showLoading" />

  </modal>
</template>
<script>

export default {
  name: "modals",

  mounted() {
    this.$bus.$on("modal-open", this._openModal);
    this.$bus.$on("modal-close", this._closeModal)
  },

  beforeDestroy(){
    this.$bus.$off("modal-open");
    this.$bus.$off("modal-close")
  },

  data() {
    return {
      showLoading: false,
      openThisCompoment: "",
      extra: {},

      modal: {
        title: ""
      },

      nextEvent: {},

      components: [
        { name: "", compoment: "" },
        { name: "propostasNET", compoment: () => import('./ModalPropostas.vue') },
        { name: "formVenda", compoment: () => import('../campaigns/FormVenda.vue') },
        { name: "formIndicao", compoment: () => import('../indicacao/IndicacaoForm.vue') },
      ]
    };
  },

  computed: {
    getComponent() {
      const [ compoment ] = this.components.filter(
        component => component.name == this.openThisCompoment
      );
      return compoment
    }
  },

  methods: {
    _closeModal(){
      this.$modal.hide("WrapperModal")
    },

    _openModal(data) {
      this.modal = {
        title: data.title || ""
      };
      this.extra = {}

      if (data.name && this.components.some(c => c.name == data.name)) {
        this.openThisCompoment = data.name;
        if(data.extra){
          this.extra = data.extra
        }
        this.$modal.show("WrapperModal");
      }

      if(data.nextEvent) {
        this.showLoading = true
        this.nextEvent = data.nextEvent
      }
    },

    compomentIsReady(){
      if(this.nextEvent.event){
        setTimeout(() => {
          this.$bus.$emit(this.nextEvent.event, this.nextEvent.data)
          this.nextEvent = {}
          this.showLoading = false
        }, this.nextEvent.delay || 0)
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// Modals.vue?bbad1c12